import { BaseApi } from "./BaseApi";

export class UnificacaoDeOrcamentosApi extends BaseApi {

    // async Listar(filtros: FiltroCotacoesPerdidas): Promise<PagedMessageResponse<TabelaCotacaoPerdida> | null> {
    //     const resposta = await this.api.post(`/CotacaoPerdida/Listar`, {
    //         filtros
    //     })

    //     return resposta.data;
    // }
}

